import {handleActions} from 'redux-actions';
import * as type from './actionTypes'
import {SpecialInfo} from './type';
const initState = {
    specialInfo: {
        ownerName: '',
        commSpecialAgreements: [],
        ctplSpecialAgreements: []
    }
}

const actions = {}

actions[type.FETCH_SPECIAL] = (state: SpecialInfo, action) => {
    console.log(action.payload)
    return{
        ...state,
        specialInfo: action.payload.result
    }
}



export const specialContentInfo = handleActions(actions, initState)
